import * as React from 'react';
import { Formik, FormikProps, FormikHelpers } from 'formik';
import { Component } from '../../../models/be/db/FormSpecification';
// eslint-disable-next-line import/no-cycle
import DataCaptureComponent from './DataCaptureComponent';
import { hasValue } from '../../../lib/utils';
import { validate, formErrorKey } from './form';
import ErrorMessage from '../../../commonComponents/ErrorMessage';
import SecondaryButton from '../buttons/SecondaryButton';
import Buttons from '../Buttons';
import PrimaryButton from '../buttons/PrimaryButton';
import { FormErrorValues } from './FormError';

const DataCapturePageSubForm = <T,>(props: Props<T>) => {
	const handleSaveButtonClick = (formikProps: FormikProps<unknown>) => async () => {
		await formikProps.submitForm();
	};

	const handleSubmit = async (values: T, actions: FormikHelpers<unknown>) => {
		const errorMessage: string = props.validate ? props.validate(values) : null;
		if (hasValue(errorMessage)) {
			actions.setFieldError(formErrorKey, errorMessage);
		} else {
			props.onSaveButtonClick(values);
		}
	};

	return (
		<Formik
			initialValues={props.values}
			validate={validate(props.components)}
			onSubmit={handleSubmit}
			validateOnBlur={false}
		>
			{(formikProps: FormikProps<FormErrorValues>) => {
				return (
					<>
						{props.components.map((c) => (
							<DataCaptureComponent
								key={c.fieldNames[0] ?? c.name}
								component={c}
								customerName=""
								isToDateReadOnly={props.isToDateReadOnly}
							/>
						))}
						{hasValue(formikProps.errors[formErrorKey]) && <ErrorMessage message={formikProps.errors[formErrorKey]} />}
						<Buttons>
							<SecondaryButton text="Cancel" onClick={() => props.onCancelButtonClick()} />
							<PrimaryButton text={props.saveButtonText} onClick={handleSaveButtonClick(formikProps)} />
						</Buttons>
					</>
				);
			}}
		</Formik>
	);
};

interface Props<T> {
	values: T;
	components: Component[];
	validate?: (values: T) => string | undefined;
	onSaveButtonClick: (values: T) => void;
	onCancelButtonClick: () => void;
	saveButtonText?: string;
	isToDateReadOnly?: boolean;
}

export default DataCapturePageSubForm;
